import { TrackingIcon } from 'icons';
import { FormattedMessage } from 'localization';

import { EnumDeskRoutes, EnumSettingRoutes, EnumTrackingRoutes } from '../../../constants';
import { SettingsSidebarMenuItem } from '../AdminSettingsSidebar';

const trackingSection: SettingsSidebarMenuItem = {
  icon: <TrackingIcon width={24} height={24} />,

  data: [
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.tracking}/${EnumTrackingRoutes.portalStyle}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk-app.settings.sidebar.portal-style" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.tracking}/${EnumTrackingRoutes.banner}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk-app.settings.sidebar.banner" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.tracking}/${EnumTrackingRoutes.smartActions}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk-app.settings.sidebar.smart-actions" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.tracking}/${EnumTrackingRoutes.translations}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk-app.settings.sidebar.translations" />
        </div>
      ),
    },
  ],
  translationKey: 'general.tracking',
};

export { trackingSection };
